import React from 'react';
import { Helmet } from "react-helmet";
import { FaShareAlt, FaComments, FaChartPie, FaPenNib, FaRocket, FaUsersCog } from 'react-icons/fa';
import "./SocialMediaMang.css";

const SocialMediaManagement = () => {
  return (
    <main className="service-page">
      <Helmet>
        <title>Social Media Management & Strategy | Skyline Bussiness Solutions</title>

        <meta 
          name="description" 
          content="Master the digital conversation with Skyline Bussiness Solutions. Visit skylinebussinesssolutions.com for expert social media management, content strategy, and community growth." 
        />

        {/* ✅ CANONICAL */}
        <link rel="canonical" href="https://skylinebussinesssolutions.com/social-media-management" />
      </Helmet>

      {/* HERO SECTION */}
      <header className="service-hero">
        <div className="service-hero-content">
          <span className="service-badge">COMMUNITY ARCHITECTURE</span>
          <h1 className="service-display">
            Social Media <br />
            <span className="accent-text">Ecosystems</span>
          </h1>

          <p className="service-intro">
            At <strong>Skyline Bussiness Solutions</strong>, we don't just "post" content; we engineer 
            <strong> digital movements</strong>. We build the social infrastructure required to 
            turn passive followers into active brand evangelists across all major networks. 
            Visit <strong>skylinebussinesssolutions.com</strong> to grow your brand.
          </p>
        </div>
      </header>

      <div className="service-container">
        
        {/* STRATEGY */}
        <section className="strategy-section">
          <div className="strategy-card">
            <div className="strat-icon"><FaPenNib /></div>
            <h3>Content Engineering</h3>
            <p>High-quality storytelling content that captures attention and drives engagement.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaUsersCog /></div>
            <h3>Algorithmic Sync</h3>
            <p>Optimizing timing, hashtags, and formats to maximize reach and engagement.</p>
          </div>

          <div className="strategy-card">
            <div className="strat-icon"><FaComments /></div>
            <h3>Community Engagement</h3>
            <p>Active interaction to build trust, loyalty, and strong brand relationships.</p>
          </div>
        </section>

        {/* CAPABILITIES */}
        <section className="capabilities-grid">
          <div className="glass-card">
            <FaShareAlt className="card-icon" />
            <h3>Omnichannel Strategy</h3>
            <p>Consistent branding across Instagram, LinkedIn, X, and more.</p>
          </div>

          <div className="glass-card">
            <FaRocket className="card-icon" />
            <h3>Paid Social Boosting</h3>
            <p>Amplifying high-performing content through targeted ads.</p>
          </div>

          <div className="glass-card">
            <FaChartPie className="card-icon" />
            <h3>Analytics & Insights</h3>
            <p>Track engagement, growth, and ROI with detailed reporting.</p>
          </div>
        </section>

        {/* WORKFLOW */}
        <section className="workflow-section">
          <div className="section-header">
            <h2>The Management Lifecycle</h2>
            <div className="line"></div>
          </div>

          <div className="workflow-steps">
            <div className="step">
              <span>01</span>
              <h4>Audit</h4>
              <p>Analyze your current social media performance.</p>
            </div>

            <div className="step">
              <span>02</span>
              <h4>Create</h4>
              <p>Design content calendar and creative assets.</p>
            </div>

            <div className="step">
              <span>03</span>
              <h4>Optimize</h4>
              <p>Improve strategy using real-time data insights.</p>
            </div>
          </div>
        </section>
      </div>

      {/* ✅ SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Social Media Management & Strategy",
          "provider": {
            "@type": "Organization",
            "name": "Skyline Bussiness Solutions",
            "url": "https://skylinebussinesssolutions.com"
          },
          "url": "https://skylinebussinesssolutions.com/social-media-management",
          "description": "Professional social media management services including content creation, engagement, and analytics."
        })}
      </script>
    </main>
  );
};

export default SocialMediaManagement;